/**
 * Increases page visit count on load and
 * saves popup timestamps on the client and
 * watches for newsletter subscribers
 */
import { PARAM_MTM_MEDIUM, PARAM_UTM_MEDIUM } from "@escapio/portal/state/utm";

const STORAGE_KEY = "newsletter-popup-tracker";

// Load (init) data
let data = JSON.parse(localStorage.getItem(STORAGE_KEY));
if (!data) {
	data = {
		pages_visited: 0,
		popup_shown: [],
		newsletter_signed_up: false,
	};
}

const write = function () {
	localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

// Increase visit counter
data.pages_visited++;

// Check for newsletter parameter in url either as MTM or as UTM param
if (
	[...new URL(document.location).searchParams.entries()]
		.filter(([key]) => [PARAM_MTM_MEDIUM, PARAM_UTM_MEDIUM].includes(key))
		.map(([, value]) => value)
		.includes("email")
) {
	data["newsletter_signed_up"] = true;
}

write();

// Get pages visited
export function getPagesVisited() {
	return data.pages_visited;
}

// Return true, if customer has aleady signed up for newsletter
export function hasSignedUp() {
	return data.newsletter_signed_up;
}

// Mark customer as newsletter subscriber
export function setSignedUp() {
	data["newsletter_signed_up"] = true;
	write();
}

// Remember time of popup showing
export function addPopupShownTimestamp(limit) {
	if (data["popup_shown"].length >= limit) {
		data["popup_shown"] = data["popup_shown"].slice(
			data["popup_shown"].length - limit + 1,
			data["popup_shown"].length,
		);
	}
	data["popup_shown"].push(Date.now());
	write();
}

// Get first known timestamp when popup was shown
export function getFirstPopupShowTimestamp() {
	return data["popup_shown"][0];
}

// Get last known timestamp when popup was shown
export function getLastPopupShowTimestamp() {
	return data["popup_shown"][data["popup_shown"].length - 1];
}

// Get number of known timestamps when popup was shown
export function getNumberOfPopupShowTimestamps() {
	return data["popup_shown"].length;
}
